// ======================================================================
// File Name       : LoginHistoryCSVForm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { TARGET_USER_TYPE } from '../../../constants/CSVDownloadConstant';
import { VALIDATE_TYPE } from '../../../constants/index';
import RenderField from '../../../utils/ReduxFormUtils';

class LoginHistoryCSVForm extends Component {
  render() {
    const {
      openExportDialog,
      isSuperuserLoginHistoryCSVPage,
      invalid, // Step 10.0.0
    } = this.props;

    return (
      <div>
        {isSuperuserLoginHistoryCSVPage ? (
          <>
            <h3 className="margin-left-20 margin-bottom-10">
              指定した検索項目に従い、SuperUserのログイン履歴をCSVファイルにダウンロードします
            </h3>
            <h3 className="margin-left-20 margin-bottom-10 textColorRed">
              ※ ログイン履歴は過去1年間分のみダウンロード可能です。
            </h3>
            <h3 className="margin-left-20 margin-bottom-10 textColorRed">
              ※ 2024/5/16以降のログイン履歴のみダウンロード可能です。
            </h3>
          </>
        )
          : (
            <>
              <h3 className="margin-left-20 margin-bottom-10">
                指定した検索項目に従い、ログイン履歴をCSVファイルにダウンロードします
              </h3>
              <h3 className="margin-left-20 margin-bottom-10 textColorRed">
                ※ ログイン履歴は過去1年間分のみダウンロード可能です。
              </h3>
              <h3 className="margin-left-20 margin-bottom-10 textColorRed">
                ※ 2024/5/16以降のログイン履歴のみダウンロード可能です。
              </h3>
            </>
          )}

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            openExportDialog();
          }}
          className='form-horizontal'
        >
          <Col sm={12} className="margin-left-20">
            <Form.Group className="form-info">
              <Col sm={3} as={Form.Label} >
                対象期間
              </Col>
              <Col sm={3}>
                <RenderField
                  type="datetime"
                  name="createdDateFrom"
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
              <Col sm={1} className="text-center" as={Form.Label}>
                ～
              </Col>
              <Col sm={3}>
                <RenderField
                  type="datetime"
                  name="createdDateTo"
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
            </Form.Group>

            <Col sm={12}>
              <RenderField
                name="dateTimeMinMax"
                type="dateTimeMinMax"
                validates={[VALIDATE_TYPE.DATE_TIME_MIN_MAX]}
                keyDateFrom="createdDateFrom"
                keyDateTo="createdDateTo"
              />
            </Col>
          </Col>

          <Form.Group className="text-center">
            <Col sm={12} className="margin-top-20 padding-left-right-clear">
              <Button variant="primary" className="btn-96" type="submit" disabled={invalid}>
                CSV出力
              </Button>
            </Col>
          </Form.Group>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { form } = state.form;
  return {
    form,
  };
};

export default connect(mapStateToProps)(LoginHistoryCSVForm);
